<template>
    <div class="container">
        <h1>Become a Corporate Key Partner</h1>
        <p>Key Corporate Partnership refers to monthly giving from your business, church, or organization toward Dream Center of Henry County’s Key Partnership fund. This type of sustainable giving allows Dream Center of Henry County to fund operations which support all of our ministry efforts!
        </p>

        <h2>Why Become a Key Partner?</h2>
        <p>
        A partnership with Dream Center of Henry County provides an opportunity for your church or business to impact the lives of countless people here in Henry County through our vision to educate, empower and disciple, while allowing your organization to take advantage of certain tax benefits.
        </p>
        <p><em>
        “Over a number of years both my wife and I were a part of different outreaches in Henry county. We were able to see up close, the need for an organization that could meet those needs. A few years ago the vision of the Dream Center of Henry County was shared with us and after visiting Dream Centers in various states and seeing what they bring to a community, we knew this was just the organization that Henry County needed!!! There are many parts of a full Dream Center that can meet the needs of food, clothing, shelter. More than that, one of the most intriguing parts of a Dream Center is the idea of not just fulfilling the basic needs, but rather finding ways to fill those needs and teach people basic life skills that they have missed that gets them off the cycle of dependence. We are happy to partner with Dream Center of Henry County financially to support this vision that is coming to life.” ~ Dream Center Key Partner Donor
        </em></p>

        <h2>How to Become a Corporate Key Partner</h2>
        <p>
            <strong>Option 1</strong>: Set up a recurring draft through your bank’s bill pay service, designating it as “Key Partnership”.<br />
            <strong>Option 2</strong>: Call us at 678-962-7775 with your credit card or bank account information, and ask to be established as a monthly Key Partner.
            <br />
            <strong>Option 3</strong>: Pay through our link <a href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=Z29RWQM4NGPGQ" target="blank">HERE</a> by PayPal or credit card.<br />
            <strong>Option 4</strong>: Fill out our donation form and return with your initial check to:<br />
            Dream Center of Henry County, 5916 East Lake Pkwy, Suite 252, McDonough, GA 30253
        </p>

        <h2>Benefits for Key Partners</h2>
        <p class="lead">Corporate partnership with Dream Center of Henry County...</p>
        <p>
            Provides your organization with a charitable tax receipt.<br />
            Adds value to your reputation in the community<br />
            Provides special name recognition on our website and social media<br />
            Adds your company’s logo and url to our website<br />
            Makes you an integral part of seeing transformation in our community!
        </p>
    </div>
</template>

<script>
export default {
  name: 'become-corporate-key-partner',
};
</script>

<style>

</style>
